import { StyledFilterButton } from "./Button-styled";
import IconButton from "./IconButton";

const FilterButton = ({ children, ...props }) => {
  return (
    <IconButton
      // selected={filterActive}
      // onClick={handleFilterGeometry}
      // disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  );

  return <StyledFilterButton {...props}>{children}</StyledFilterButton>;
};

export default FilterButton;
